import React from "react";
import { Building2, Users, Wallet, TrendingUp, FileBarChart, CloudRain } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import FranchiseReportTab from "@/components/reports/FranchiseReportTab";
import DPReportTab from "@/components/reports/DPReportTab";
import PaymentReportTab from "@/components/reports/PaymentReportTab";
import EarningsReportTab from "@/components/reports/EarningsReportTab";
import DailyReportTab from "@/components/reports/DailyReportTab";
import ExportsTab from "@/components/reports/ExportsTab";

const PERIOD_VIEW = ["daily", "weekly", "monthly", "quarterly", "yearly", "custom"].map((p) => `rep.view_${p}`);
const TABS = [
  { v: "franchise", label: "Franchise", icon: Building2, el: <FranchiseReportTab />, perms: ["fr.reports"] },
  { v: "dp", label: "Delivery Partners", icon: Users, el: <DPReportTab />, perms: PERIOD_VIEW },
  { v: "payments", label: "Payments", icon: Wallet, el: <PaymentReportTab />, perms: ["pay.history"] },
  { v: "earnings", label: "Earnings", icon: TrendingUp, el: <EarningsReportTab />, perms: PERIOD_VIEW },
  { v: "daily", label: "Daily & Rain", icon: CloudRain, el: <DailyReportTab />, perms: PERIOD_VIEW },
  { v: "exports", label: "Exports & Bulk", icon: FileBarChart, el: <ExportsTab />, perms: ["rep.bulk_exports"] },
];

export default function Reports() {
  const { canAny } = useAuth();
  const tabs = TABS.filter((t) => canAny(...t.perms));
  if (!tabs.length) return <p className="text-muted-foreground">No reports available for your account.</p>;
  return (
    <div>
      <PageHeader title="Reports & Export" subtitle="Franchise, Delivery Partner, Payment & Earnings reports with Excel / CSV / PDF export" />
      <Tabs defaultValue={tabs[0].v}>
        <TabsList className="mb-4 h-auto flex-wrap gap-1 bg-muted/60">
          {tabs.map((t) => (
            <TabsTrigger key={t.v} value={t.v} data-testid={`reports-tab-${t.v}`} className="gap-1.5">
              <t.icon className="h-4 w-4" />{t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {TABS.map((t) => (
          <TabsContent key={t.v} value={t.v}>{t.el}</TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
